import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => {
  return jsonFormData({ project_qa_ndt_booking: data }, { showLeafArrayIndexes: false });
};

export const GET_PROJECT_QA_NDT_BOOKINGS = "get_project_qa_ndt_bookings";
export const getProjectQaNdtBookings = (get_all) => {
  let url = "/project/qa/ndt_bookings.json";
  if (get_all) {
    url += "?get_all";
  }
  const request = axios.get(url);
  return {
    type: GET_PROJECT_QA_NDT_BOOKINGS,
    payload: request,
  };
};

export const CREATE_PROJECT_QA_NDT_BOOKING = "create_project_qa_ndt_booking";
export const createProjectQaNdtBooking = (data) => {
  const url = "/project/qa/ndt_bookings.json";
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_PROJECT_QA_NDT_BOOKING,
    payload: request,
  };
};

export const GET_PROJECT_QA_NDT_BOOKING = "get_project_qa_ndt_booking";
export const getProjectQaNdtBooking = (id) => {
  const url = `/project/qa/ndt_bookings/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_PROJECT_QA_NDT_BOOKING,
    payload: request,
  };
};

export const UPDATE_PROJECT_QA_NDT_BOOKING = "update_project_qa_ndt_booking";
export const updateProjectQaNdtBooking = (id, data) => {
  const url = `/project/qa/ndt_bookings/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_PROJECT_QA_NDT_BOOKING,
    payload: request,
  };
};

export const SEND_PROJECT_QA_NDT_BOOKING_PDF = "send_project_qa_ndt_booking_pdf";
export const sendProjectQaNdtBookingPdf = (id, poNumber) => {
  const url = `/project/qa/ndt_bookings/${id}/send_booking_pdf.json`;
  const request = axios.post(url, { po_number: poNumber });
  return {
    type: SEND_PROJECT_QA_NDT_BOOKING_PDF,
    payload: request,
  };
};

export const CREATE_PROJECT_QA_NDT_BOOKING_PO = "create_project_qa_ndt_booking_po";
export const createProjectQaNdtBookingPo = (id, data = {}) => {
  const url = `/project/qa/ndt_bookings/${id}/create_po.json`;
  const request = axios.post(url, { project_qa_ndt_booking: data });
  return {
    type: CREATE_PROJECT_QA_NDT_BOOKING_PO,
    payload: request,
  };
};
